import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-705330d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  "data-testid": "OArvoreDeSelecoes__Componente"
}
const _hoisted_2 = {
  class: "OArvoresDeSelecoes__CabecalhoDaLista",
  "data-testid": "OArvoresDeSelecoes__CabecalhoDaLista"
}
const _hoisted_3 = { class: "OArvoresDeSelecoes__CorpoDoTitulo" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "OArvoreDeSelecoes__NumeroSelecionados" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "OArvoreDeSelecoes__EstadoDeVazio"
}

import VirtualScroller from "primevue/virtualscroller"
  import { TreeNode } from "primevue/tree"
  import TriStateCheckbox from "primevue/tristatecheckbox"
  import { MCheckbox, ChaveValor, ArvoreDeSelecoes } from "@/components/Gerais"
  import { WritableComputedRef, computed, ref } from "vue"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { useI18n } from "vue-i18n"

  interface Props {
    selecionados: Array<ChaveValor<string>>
    nos: ArvoreDeSelecoes[]
    estaCarregando: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OArvoreDeSelecoes',
  props: {
    selecionados: null,
    nos: null,
    estaCarregando: { type: Boolean }
  },
  emits: ["atualizar:selecionados"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "atualizar:selecionados", selecionados: ChaveValor<string>[]): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    selecionados: Array<ChaveValor<string>>
    nos: ArvoreDeSelecoes[]
    estaCarregando: boolean
  }

  const { t } = useI18n()

  const { colher } = usarManipuladorObjetos()
  
  const listaMaximizada = ref(0)
  const chaveDaLista = ref<string[]>([])
  const ESTADO_DE_VAZIO = "estado-de-vazio"
  const ALTURA_MAXIMA_DA_LISTA = 267

  

  const emitirNosSelecionados: WritableComputedRef<Array<ChaveValor<string>>> =
    computed({
      get(): Array<ChaveValor<string>> {
        return props.selecionados
      },
      set(nosSelecionados: Array<ChaveValor<string>>) {
        emitir("atualizar:selecionados", nosSelecionados)
      },
    })

  const numeroDeSelecionados = computed(() => {
    return (chave: string): string => {
      const noFilho = props.nos.find((no) => no.key === chave)!.children
      const selecionadosDaChave = props.selecionados.filter(
        (selecionado) => selecionado.chave === chave
      )

      const quantidadeFiltrada = selecionadosDaChave.reduce(
        (acumulador, selecionados) => {
          const quantidade = noFilho.filter(
            (no) => selecionados.valor === no.valor && no.contemNoFiltro
          ).length
          return acumulador + quantidade
        },
        0
      )

      return `(${quantidadeFiltrada})`
    }
  })

  const definirSeListaEstaMaximizada = computed(() => {
    return (posicaoDaLista: number): string | null => {
      const ehAListaMaximizada = listaMaximizada.value === posicaoDaLista
      if (ehAListaMaximizada) {
        return "OArvoreDeSelecoes__Maximizada"
      }

      return null
    }
  })

  const definirAlturaDaLista = computed(() => {
    return (posicaoDaLista: number): string | null => {
      const ehAListaMaximizada = listaMaximizada.value === posicaoDaLista
      const quantidadeDeListas = props.nos.length
      const alturaDoCabecalho = 40
      const altura =
        ALTURA_MAXIMA_DA_LISTA + quantidadeDeListas * alturaDoCabecalho

      if (ehAListaMaximizada) {
        return `height: calc(100vh - ${altura}px) !important;`
      }

      return null
    }
  })

  const seTodosEstaoSelecionados = (
    no: ArvoreDeSelecoes,
    quantidadeDeNosDaChave: number
  ): boolean | null => {
    const calcularQuantidadeDeSelecionados = () => {
      return props.selecionados.filter(
        (selecionado) =>
          selecionado.chave === no.key &&
          no.children.some(
            (filho) => filho.contemNoFiltro && filho.valor === selecionado.valor
          )
      ).length
    }

    const quantidadeDeSelecionadosDaChave = calcularQuantidadeDeSelecionados()

    const listaNaoPossuiItens = (): boolean => {
      return (
        no.children.filter((noFilho) => noFilho.contemNoFiltro).length === 0
      )
    }

    if (listaNaoPossuiItens()) {
      return null
    }

    if (quantidadeDeSelecionadosDaChave === quantidadeDeNosDaChave) {
      return true
    }

    if (
      quantidadeDeSelecionadosDaChave > 0 &&
      quantidadeDeSelecionadosDaChave < quantidadeDeNosDaChave
    ) {
      return false
    }

    return null
  }

  const selecionarTodosDaChave = (
    chave: string,
    filhos: ArvoreDeSelecoes["children"],
    quantidadeDeNosDaChave: number
  ): void => {
    const calcularQuantidadeDeSelecionados = () => {
      return props.selecionados.filter(
        (selecionado) =>
          selecionado.chave === chave &&
          filhos.some(
            (no) => no.contemNoFiltro && no.valor === selecionado.valor
          )
      ).length
    }

    const removerSelecionadosConsiderandoFiltrados = () => {
      return selecionados.filter((selecionado) => {
        const filhosDoMesmoNoQueNaoEstaoFiltrados = !filhosMarcados.some(
          (itemFiltrado) => itemFiltrado.valor === selecionado.valor
        )

        return (
          selecionado.chave !== chave || filhosDoMesmoNoQueNaoEstaoFiltrados
        )
      })
    }

    let selecionados = props.selecionados
    const totalDeSelecionadosDaChave = calcularQuantidadeDeSelecionados()
    const filhosMarcados = filhos.filter((no) => no.contemNoFiltro)

    if (totalDeSelecionadosDaChave === quantidadeDeNosDaChave) {
      selecionados = removerSelecionadosConsiderandoFiltrados()
    } else {
      selecionados = removerSelecionadosConsiderandoFiltrados()
      selecionados.push(
        ...colher<TreeNode, ChaveValor<string>>(filhosMarcados, [
          "chave",
          "valor",
        ])
      )
    }
    emitir("atualizar:selecionados", selecionados)
  }

  const definirItensDaLista = (no: ArvoreDeSelecoes) => {
    const itensFiltrados = no.children.filter(
      (noFilho) => noFilho.contemNoFiltro
    )

    if (itensFiltrados.length > 0) {
      return itensFiltrados
    }

    return [{ valor: ESTADO_DE_VAZIO, key: ESTADO_DE_VAZIO, rotulo: "" }]
  }

  const lidarComExpansaoDaLista = (posicaoDaLista: number): void => {
    if (posicaoDaLista === listaMaximizada.value) {
      listaMaximizada.value = -1
      return
    }
    listaMaximizada.value = posicaoDaLista
    chaveDaLista.value[posicaoDaLista] = `${
      props.nos[posicaoDaLista].rotulo
    }${new Date().getTime()}`
  }

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (__props.estaCarregando)
    ? (_openBlock(), _createBlock(_component_Skeleton, {
        key: 0,
        "data-testid": "OArvoreDeSelecoes__Carregando",
        height: `calc(100vh - ${ALTURA_MAXIMA_DA_LISTA}px)`,
        width: "100%"
      }, null, 8, ["height"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.nos, (no, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: no.key
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(TriStateCheckbox), {
                  "onUpdate:modelValue": ($event: any) => (
              selecionarTodosDaChave(
                no.key,
                no.children,
                no.$quantidadeFiltrada()
              )
            ),
                  "aria-labelledby": no.key,
                  class: "OArvoresDeSelecoes__SelecionarTodos OArvoreDeSelecoes__SelecionarTodos--indeterminado",
                  "data-testid": "OArvoreDeSelecoes__SelecionarTodos",
                  "model-value": 
              seTodosEstaoSelecionados(no, no.$quantidadeFiltrada())
            
                }, null, 8, ["onUpdate:modelValue", "aria-labelledby", "model-value"]),
                _createElementVNode("em", {
                  id: no.key,
                  class: _normalizeClass(no.icone)
                }, null, 10, _hoisted_4),
                _createElementVNode("h2", {
                  id: no.key
                }, _toDisplayString(no.rotulo), 9, _hoisted_5),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(numeroDeSelecionados)(no.key)), 1)
              ]),
              _createElementVNode("a", {
                onClick: ($event: any) => (lidarComExpansaoDaLista(index)),
                class: "OArvoresDeSelecoes__BotaoExpandirLista",
                "data-testid": "OArvoresDeSelecoes__BotaoExpandirLista"
              }, [
                _createElementVNode("em", {
                  class: _normalizeClass(["pi", 
              listaMaximizada.value === index ? 'pi-chevron-down' : 'pi-chevron-right'
            ])
                }, null, 2)
              ], 8, _hoisted_7)
            ]),
            (_openBlock(), _createBlock(_unref(VirtualScroller), {
              key: chaveDaLista.value[index],
              class: _normalizeClass(["OArvoreDeSelecoes__Lista", _unref(definirSeListaEstaMaximizada)(index)]),
              "data-testid": "OArvoreDeSelecoes__Lista",
              "item-size": 45,
              items: definirItensDaLista(no),
              style: _normalizeStyle(_unref(definirAlturaDaLista)(index))
            }, {
              item: _withCtx(({ item }) => [
                (item.valor !== 'estado-de-vazio')
                  ? (_openBlock(), _createBlock(_unref(MCheckbox), {
                      key: 0,
                      modelValue: _unref(emitirNosSelecionados),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirNosSelecionados) ? (emitirNosSelecionados).value = $event : null)),
                      id: item.key,
                      class: "OArvoresDeSelecoes__Checkbox rotulo",
                      "data-testid": "OArvoresDeSelecoes__Checkbox",
                      "habilitar-dica": "",
                      label: item.rotulo,
                      nome: item.key,
                      valor: { chave: item.chave, valor: item.valor }
                    }, null, 8, ["modelValue", "id", "label", "nome", "valor"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('nenhumResultadoEncontrado')), 1))
              ]),
              _: 2
            }, 1032, ["class", "items", "style"]))
          ]))
        }), 128))
      ]))
}
}

})